<div class="work-object-pause-resume-mat-dialog">
  <div class="detail-card-header">
    <span whFlex class="w-h-header-icon-span">
      <i
        mat-card-avatar
        class="workheld-icons header-icon"
        [innerHtml]="cancelIcon"
      ></i>
    </span>
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{ "workobject.ui.close.header.label" | translate }}
      </div>
    </span>
  </div>
  <div class="work-object-pause-resume-mat-dialog-body">
    <form [formGroup]="payloadFormGroup">
      <div fxLayout="column" fxLayoutAlign="left stretch" fxLayoutGap="20px">
        <div style="padding-top: 6px">
          <div>
            <mat-form-field class="data">
              <mat-label>{{
                "workobject.model.close.reason" | translate
              }}</mat-label>
              <mat-select formControlName="reason" required>
                <mat-option
                  *ngFor="let pauseReason of ENUMS.CLOSE_CAUSE | whenum"
                  [value]="pauseReason?.id"
                >
                  {{ pauseReason?.translateKey | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div>
        <mat-form-field whFlex>
          <mat-label>{{
            "workobject.model.pauseresume.comment" | translate
          }}</mat-label>
          <textarea
            matInput
            [rows]="10"
            [required]="false"
            [formControlName]="'comment'"
          ></textarea>
        </mat-form-field>
      </div>
    </form>
    <w-h-button-group align="end" mat-dialog-actions>
      <w-h-button
        [text]="'app.cancel.label' | translate | uppercase"
        matIcon="close"
        type="stroked"
        (clicked)="closeDialog()"
      />
      <w-h-button
        [text]="'app.save.label' | translate | uppercase"
        matIcon="save"
        color="accent"
        type="flat"
        [disabled]="isFormGroupInvalid"
        (clicked)="handleSubmit()"
      />
    </w-h-button-group>
  </div>
</div>
